import { useEffect, useState } from "react";

export function useRelativeTop(parentRef, childRef) {
  const [relativeTop, setRelativeTop] = useState(0);

  useEffect(() => {
    const parent = parentRef.current;
    const child = childRef.current;
    if (!parent || !child) return;

    const update = () => {
      const parentRect = parent.getBoundingClientRect();
      const childRect = child.getBoundingClientRect();
      setRelativeTop(childRect.top - parentRect.top);
    };

    update();
    parent.addEventListener("scroll", update);

    return () => parent.removeEventListener("scroll", update);
  }, [parentRef, childRef]);

  return relativeTop;
}
